module.exports = __webpack_public_path__ + "static/media/icon_following.c97c1633.svg";